import { render } from "./ResumePage.vue?vue&type=template&id=65c75d0b&scoped=true"
import script from "./ResumePage.vue?vue&type=script&lang=js"
export * from "./ResumePage.vue?vue&type=script&lang=js"

import "./ResumePage.vue?vue&type=style&index=0&id=65c75d0b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c75d0b"]])

export default __exports__